"use strict";
// packages/types/src/api/approvedSupplier.ts
Object.defineProperty(exports, "__esModule", { value: true });
